// extracted by mini-css-extract-plugin
export default {"counter":"Counter_counter__mbnDr","value":"Counter_value__Np2Ub"};